export const initialCasesAmount = 75;
export const casesLoadAmount = 25;
